<!-- filepath: /C:/Users/jelli/portfolio/vue-portfolio/src/components/Footer.vue -->
<template>
  <footer class="bg-gray-800 text-white py-4">
    <div class="container mx-auto text-center">
      <p>&copy; 2025 Jacob Elliot Stocker</p>
      <p>
        <a href="https://github.com/jelliots2" class="text-blue-400 hover:underline" target="_blank" rel="noopener noreferrer">GitHub</a> |
        <a href="https://www.linkedin.com/in/jacob-stocker-bb781a333/" class="text-blue-400 hover:underline" target="_blank" rel="noopener noreferrer">LinkedIn</a> |
        <a href="mailto:jelliot.stocker@gmail.com" class="text-blue-400 hover:underline">Email</a>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterBar'
};
</script>

<style scoped>
footer {
  background-color: #2d3748; /* Tailwind's gray-800 */
  color: #ffffff; /* White text */
  padding: 1rem 0; /* Vertical padding */
  position: fixed; /* Fixed position */
  bottom: 0; /* Align to bottom */
  left: 0; /* Align to left */
  width: 100%; /* Full width */
}

a {
  color: #63b3ed; /* Tailwind's blue-400 */
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}
</style>